import { render } from "./SelecionarTipoProduto.vue?vue&type=template&id=599ad551&ts=true"
import script from "./SelecionarTipoProduto.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoProduto.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__